// 自動スクロール用スクリプト

document.querySelectorAll('.wp-block-lpc-blocks-move-card-list').forEach(wrapper => {
    const track = wrapper.querySelector('.lpcb-move-card-swipe-scroll-track');
    if (!track) return;

    // ボタンがあるときだけクラスを付ける（position: relative用）
    if (wrapper.querySelector('.lpcb-move-card-swipe-scroll-button')) {
        wrapper.classList.add('has-swipe-scroll-buttons');
    } 
    // スクロールで更新
    track.addEventListener('scroll', () => lpcbMoveCardSwipeUpdateButtons(wrapper));
  
    // ウィンドウサイズ変更でも再判定
    window.addEventListener('resize', () => lpcbMoveCardSwipeUpdateButtons(wrapper));
  
    // 初回チェックを必ず実行
    lpcbMoveCardSwipeUpdateButtons(wrapper);
});

// 前後ボタンのクリック制御
document.querySelectorAll('.lpcb-move-card-swipe-scroll-button').forEach(button => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.wp-block-lpc-blocks-move-card-list');
      if (!wrapper) return;

      const scrollTrack = wrapper.querySelector('.lpcb-move-card-swipe-scroll-track');
      if (!scrollTrack) return;

      const cards = Array.from(scrollTrack.querySelectorAll('.wp-block-lpc-blocks-move-card'));
      if (cards.length === 0) return;

      const containerCenter = scrollTrack.scrollLeft + scrollTrack.offsetWidth / 2;

      let currentIndex = 0;
      let minDist = Infinity;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - containerCenter);
        if (distance < minDist) {
          minDist = distance;
          currentIndex = index;
        }
      });

      const nextIndex = button.classList.contains('next')
        ? Math.min(currentIndex + 1, cards.length - 1)
        : Math.max(currentIndex - 1, 0);

      const targetCard = cards[nextIndex];
      // const scrollTo = targetCard.offsetLeft + targetCard.offsetWidth / 2 - scrollTrack.offsetWidth / 2;
      const scrollTo = Math.min(
        targetCard.offsetLeft + targetCard.offsetWidth / 2 - scrollTrack.offsetWidth / 2,
        scrollTrack.scrollWidth - scrollTrack.clientWidth
      );

      scrollTrack.scrollTo({
        left: scrollTo,
        behavior: 'smooth',
      });

      lpcbMoveCardSwipeUpdateButtons(wrapper);
    });
});

function lpcbMoveCardSwipeIsScrollable(track) {
    return track.scrollWidth > track.clientWidth + 1;
}
function lpcbMoveCardSwipeUpdateButtons(wrapper) {
    const track = wrapper.querySelector('.lpcb-move-card-swipe-scroll-track');
    const prevButton = wrapper.querySelector('.lpcb-move-card-swipe-scroll-button.prev');
    const nextButton = wrapper.querySelector('.lpcb-move-card-swipe-scroll-button.next');
    const isTablet = window.matchMedia('(max-width: 991px)').matches;

    if (!track || !prevButton || !nextButton) return;

    if (!lpcbMoveCardSwipeIsScrollable(track)) {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
      return;
    }

    if (isTablet) {
      // 最初はCSSで表示、スクロールされたら JS で非表示にする
      if (track.scrollLeft > 10) {
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
      }
      // return することでPC用制御をスキップ
      return; 
    }

    // PC制御
    prevButton.style.display = track.scrollLeft <= 10 ? 'none' : 'block';
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    nextButton.style.display = track.scrollLeft >= maxScrollLeft - 2 ? 'none' : 'block';
}